export default {
  contactMessage: {
    name: "Contact Message",
    home: {
      title: "Contact Messages",
      createLabel: "Create Contact Message",
    },
    detail: {
      title: "Contact Message",
    },
    fields: {
      email: "Email",
      name: "Name",
      subject: "Subject",
      message: "Message",
      sujectOptions: {
        partnership: "Partnership",
        consulting: "Consulting",
        consultation: "Free Consultation",
        process: "Process",
        ai: "AI",
        question: "Question",
        other: "Other",
      },
    },
    actions: {
      delete: {
        label: "Delete",
        confirm: "Are you sure you want to delete contact message %{name}?",
      },
      deleteMessage: "Delete message",
    },
  },
};
